import AIMS_FLAVORS from 'lib/aimsFlavors';

export const sixSlotLayout = {
  tease0: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_380x190,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_260x130,
      },
      display: 'db',
    },
    headlineSizes: 'f7 f5-m f6-l f6-xl',
    headlineTextPositioning: '',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn',
    },
  },
  tease1: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
        l: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db dn-m',
    },
    headlineSizes: 'f6 f5-m f6-l f6-xl',
    headlineTextPositioning: 'pl4-m',
    mediaLabel: {
      eyebrowDisplay: 'dn',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-m',
    },
  },
  tease2: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_380x190,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db',
    },
    headlineSizes: 'f7 f5-m f6-l f5-xl',
    headlineTextPositioning: '',
    mediaLabel: {
      eyebrowDisplay: 'db dn-xl',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn',
    },
  },
  tease3: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db',
    },
    headlineSizes: 'f6 f5-m f6-l f5-xl',
    headlineTextPositioning: '',
    mediaLabel: {
      eyebrowDisplay: 'dn db-m dn-xl',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn',
    },
  },
  tease4: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db',
    },
    headlineSizes: 'f6 f5-m f6-l f5-xl',
    headlineTextPositioning: '',
    mediaLabel: {
      eyebrowDisplay: 'dn db-m dn-xl',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn',
    },
  },
};
